import { PaginationProps } from '@/shared/Pagination'
import { boxImportTypes } from '@/shared/SelectData'
import { TemplateItem } from '@/template/interface'
import { getFormatMessage, groupBy } from '@/utils/utils'
import { message, Modal } from 'antd'
import moment from 'moment'
import React, { Fragment, useEffect, useState } from 'react'
import { BoxJobListModal } from './job/modal'
import { BoxContactModal } from './contact/modal'
import { BoxEditModal } from './edit'
import { BoxFirmwareModal } from './firmware/modal'
import { BoxImportModal } from './import/modal'
import {
  BoxConnectionItem,
  BoxFirmwareItem,
  BoxImportSearchItem,
  BoxItem,
  BoxJobStateItem,
  BoxProps,
  BoxSearchItem,
  BoxTimeItem,
  BoxUpdateItem,
  BoxJobProgressItem,
  BoxStateItem,
  BoxErrorItem
} from './interface'
import { BoxList } from './list'
import { BoxTable } from './table'
import { BoxToolbar } from './toolbar'
import { BoxActionbar } from './toolbar/actionbar'
import { BoxDetailConnectionModal } from './detail/basic/connection/modal'
import { BoxDetailTimeModal } from './detail/basic/time/modal'
import { BoxDetailDrawer } from './detail/drawer'
import { Guid } from '@/utils/guid'
import { BoxErrorCode } from '@/shared/Errors'
import { BoxUpgradeModal } from './upgrade'
import { logger } from '@/utils/logger'

export const Box: React.FC<BoxProps> = (props: BoxProps) => {
  const {
    listType,
    importTypes,
    boxStateItem,
    boxJobProgressItem,
    boxFoundItem,
    boxValueItems,
    boxErrorItem,
    boxUpgradeItem,
    onBoxListLoad,
    onBoxDetailLoad,
    onTemplateListLoad,
    onTemplateApply,
    onBoxTemplateLoad,
    onBoxAuditListLoad,
    onBoxLogListLoad,
    onJobListLoad,
    onJobStateLoad,
    onBoxImport,
    onBoxDelete,
    onBoxReboot,
    onBoxFirmwareUpdate,
    onBoxOldFirmwareUpdate,
    onBoxApnUpdate,
    onBoxNetworkModeUpdate,
    onBoxNetworkUpdate,
    onBoxConnectionUpdate,
    onBoxTimeUpdate,
    onBoxUpdate,
    onBoxSelect,
    onBoxFavorite,
    onBoxTagLoad,
    onBoxTcpLoad,
    onBoxUsbLoad,
    onBoxTcpScan,
    onBoxValueRead,
    onBoxValueWrite,
    onBoxValueSubscribe,
    onBoxVariablePushChange,
    onBoxAlarmPushChange,
    onBoxNatIpUpdate,
    onBoxWifiLoad,
    onBoxClean
  } = props
  const formatMessage = getFormatMessage()
  const [boxes, setBoxes] = useState<BoxItem[]>([])
  const [boxTotal, setBoxTotal] = useState<number>(0)
  const [boxCheckItems, setBoxCheckItems] = useState<BoxItem[]>([])
  const [boxBatchItems, setBoxBatckItems] = useState<BoxItem[]>([])
  const [boxImportVisible, setBoxImportVisible] = useState<boolean>(false)
  const [boxImportItems, setBoxImportItems] = useState<BoxItem[]>([])
  const [boxFirmwareVisible, setBoxFirmwareVisible] = useState<boolean>(false)
  const [boxContactVisible, setBoxContactVisible] = useState<boolean>(false)
  const [boxConnectionEditItem, setBoxConnectionEditItem] =
    useState<BoxConnectionItem>()
  const [boxConnectionEditVisible, setBoxConnectionEditVisible] =
    useState<boolean>(false)
  const [boxTimeEditItem, setBoxTimeEditItem] = useState<BoxTimeItem>()
  const [boxTimeEditVisible, setBoxTimeEditVisible] = useState<boolean>()
  const [boxEditItem, setBoxEditItem] = useState<BoxItem>()
  const [boxEditVisible, setBoxEditVisible] = useState<boolean>(false)
  const [boxJobVisible, setBoxJobVisible] = useState<boolean>(false)
  const [boxJobStates, setBoxJobStates] = useState<BoxJobStateItem[]>([])
  const [boxDetailVisible, setBoxDetailVisible] = useState<boolean>(false)
  const [boxSelectItem, setBoxSelectItem] = useState<BoxItem>()
  const [boxImportType, setBoxImportType] = useState<number>()
  const [templates, setTemplates] = useState<TemplateItem[]>([])
  const [templateTotal, setTemplateTotal] = useState<number>(0)
  const [jobProgressItem, setJobProgressItem] = useState<BoxJobProgressItem>()
  const [selectable, setSelectable] = useState<boolean>(false)
  const [checkAll, setCheckAll] = useState<boolean>(false)
  const [boxUpgradeVisible, setBoxUpgradeVisible] = useState<boolean>(false)
  const [boxHandleItem, setBoxHandleItem] = useState<BoxItem>()
  const [boxSearch, setBoxSearch] = useState<BoxSearchItem>()

  const boxTablePagination: PaginationProps = {
    total: boxTotal,
    onChange: async (pageNumber: number, pageSize?: number) => {
      const skip = (pageNumber - 1) * (pageSize || 10)
      await loadBoxes(skip, boxSearch)
    }
  }

  // 盒子事件
  const boxEvents = {
    edit: (items: BoxItem[]) => {
      setBoxEditItem(items[0])
      setBoxEditVisible(true)
    },
    delete: (items: BoxItem[]) => {
      handleBoxDelete(items)
    },
    reboot: (items: BoxItem[]) => {
      if (!checkBoxState(items)) {
        return
      }
      handleBoxReboot(items)
    },
    firmware: (items: BoxItem[]) => {
      if (!checkBoxState(items)) {
        return
      }
      const g = groupBy(items, (x: any) => x.boxType)
      if (Object.keys(g).length > 1) {
        message.error(formatMessage({ id: 'app.box.prompt.typeError' }))
        return
      }
      setBoxBatckItems(items)
      setBoxFirmwareVisible(true)
    },
    template: async (items: BoxItem[]) => {
      if (!checkBoxState(items)) {
        return
      }
      await loadTemplates(0)
      setBoxBatckItems(items)
      setBoxContactVisible(true)
    },
    connection: (items: BoxItem[]) => {
      if (!checkBoxState(items)) {
        return
      }
      setBoxConnectionEditItem({
        mode: 'mqtt',
        server: '',
        mqttVersion: '5.0',
        connectTimeout: 30,
        cleansession: 1,
        keepAlive: 60
      })
      setBoxBatckItems(items)
      setBoxConnectionEditVisible(true)
    },
    time: (items: BoxItem[]) => {
      if (!checkBoxState(items)) {
        return
      }
      setBoxTimeEditItem({
        timezone: 'Asia/Shanghai',
        ntpserver: 'time.fbox360.net',
        dateTime: moment()
      })
      setBoxBatckItems(items)
      setBoxTimeEditVisible(true)
    },
    detail: (items: BoxItem[]) => {
      setBoxSelectItem(items[0])
      setBoxDetailVisible(true)
    },
    clean: (items: BoxItem[]) => {
      if (!checkBoxState(items)) {
        return
      }
      handleBoxClean(items)
    }
  }

  // 盒子导入类型
  const boxImportTypeItems = importTypes
    ? boxImportTypes.filter((x) => importTypes.includes(x.value))
    : boxImportTypes

  // 检查盒子状态
  const checkBoxState = (items: BoxItem[]) => {
    const offlineBoxes = items.filter((x) => x.connectionState !== 1)
    if (offlineBoxes && offlineBoxes.length > 0) {
      const msg = offlineBoxes.map((x) => `【${x.boxNo}】`).join('、')
      Modal.error({
        title: formatMessage({ id: 'app.modal.title' }),
        content: formatMessage({
          id: 'app.box.prompt.offlineError',
          parameters: { boxNos: msg }
        })
      })
      return false
    }
    return true
  }

  // 盒子排序
  const sortBox = (a: BoxItem, b: BoxItem) => {
    if (a.favorite && b.favorite) {
      if (a.boxNo! < b.boxNo!) {
        return -1
      } else {
        return 1
      }
    } else if (a.favorite && !b.favorite) {
      return -1
    } else if (!a.favorite && b.favorite) {
      return 1
    }
    if (a.connectionState === b.connectionState) {
      if (a.boxNo! < b.boxNo!) {
        return -1
      } else {
        return 1
      }
    } else if (a.connectionState === 1 && b.connectionState !== 1) {
      return -1
    } else if (a.connectionState !== 1 && b.connectionState === 1) {
      return 1
    }
    return 0
  }

  const updateCheckItems = (data: BoxItem[]) => {
    const boxNos = data.map((x) => x.boxNo)
    const boxCheckNos = boxCheckItems
      .filter((x) => boxNos.includes(x.boxNo))
      .map((x) => x.boxNo)
    setBoxCheckItems(data.filter((x) => boxCheckNos.includes(x.boxNo)))

    const boxBatchNos = boxBatchItems
      .filter((x) => boxNos.includes(x.boxNo))
      .map((x) => x.boxNo)
    setBoxBatckItems(data.filter((x) => !boxBatchNos.includes(x.boxNo)))
  }

  // 加载盒子列表
  const loadBoxes = async (skip: number = 0, args?: BoxSearchItem) => {
    const take = listType === 'table' ? 10 : 999
    const result = await onBoxListLoad?.(skip, take, args)
    const data = (result?.items || []).sort(sortBox)
    setBoxes(data)
    setBoxTotal(result?.totalCount || 0)
    updateCheckItems(data)
  }

  // 加载模板列表
  const loadTemplates = async (skip: number = 0, args?: any) => {
    const result = await onTemplateListLoad?.(skip, args)
    setTemplates(result?.items || [])
    setTemplateTotal(result?.totalCount || 0)
  }

  // 加载任务状态
  const loadJobStates = async (defaultState: number) => {
    const result = await onJobStateLoad?.(defaultState)
    setBoxJobStates(result || [])
  }

  // 加载任务列表
  const showBoxJobModal = async () => {
    await loadJobStates(1)
    setBoxJobVisible(true)
  }

  // 更新列表中的盒子信息
  const updateBox = (newItem: BoxItem) => {
    const i = boxes.findIndex((x) => x.id === newItem.id)
    if (i >= 0) {
      let newList = [...boxes]
      newList[i] = newItem
      newList = newList.sort(sortBox) // 重新排序
      setBoxes(newList)
      updateCheckItems(newList)
    }
  }

  // 更新列表中盒子状态
  const updateBoxState = async (item: BoxStateItem) => {
    logger.info(`updateBoxState: ${item.id}, ${item.connectionState}`)
    // 如果设备在当前列表中
    const box = boxes.find((x) => x.id === item.id)
    // 设备存在且至少在过一次线（可以直接更新，否则重新加载，防止新导入的设备信息不完整）
    if (box && box.lastOnline) {
      if (
        item.connectionState === 4 ||
        box.connectionState !== item.connectionState
      ) {
        const newBox = { ...box }
        newBox.connectionState = item.connectionState
        updateBox(newBox)
      }
    } else {
      await loadBoxes()
    }
  }

  // 搜索盒子列表
  const handleSearch = async (args: BoxSearchItem) => {
    setBoxSearch(args)
    await loadBoxes(0, args)
  }

  // 列表右键菜单或表格操作菜单
  const handleMenuItemClick = (key: string, item?: BoxItem) => {
    // 列表右键菜单事件(表格单行菜单事件)
    if (item) {
      const arr = [item]
      boxEvents[key]?.(arr)
      return
    }

    // 批量菜单事件
    if (boxCheckItems.length <= 0) {
      message.error('请先在设备列表上勾选设备')
      return
    }
    boxEvents[key]?.(boxCheckItems)
  }

  // 导入csv文件
  const handleFileSelect = (items: BoxItem[]) => {
    setBoxImportItems(items)
  }

  // 搜索导入设备列表
  const handleImportSearch = async (item: BoxImportSearchItem) => {
    setBoxImportType(item.importType)
    switch (item.importType) {
      case 0: // usb
        if (onBoxUsbLoad) {
          const usbBox = await onBoxUsbLoad()
          if (usbBox) {
            usbBox.comMode = 1
            usbBox.alias = usbBox.boxNo
            usbBox.id = Guid.raw()
            setBoxImportItems([usbBox])
          } else {
            setBoxImportItems([])
          }
        }
        break
      case 1: // 广播搜索
        if (onBoxTcpScan) {
          await onBoxTcpScan()
        }
        break
      case 2: // 指定IP
        if (onBoxTcpLoad) {
          const tcpBox = await onBoxTcpLoad(item.ip || '')
          if (tcpBox) {
            tcpBox.comMode = 2
            tcpBox.natIp = item.ip
            tcpBox.alias = tcpBox.boxNo
            tcpBox.id = Guid.raw()
            setBoxImportItems([tcpBox])
          } else {
            setBoxImportItems([])
          }
        }
        break
      case 3: // 文件
        break
      case 4: // 标签
        if (onBoxTagLoad) {
          const tagBox = await onBoxTagLoad(item.boxNo!, item.userPassword!)
          tagBox.comMode = 0 // mqtt
          tagBox.id = Guid.raw()
          if (tagBox) {
            const newItems = boxImportItems
              .filter((x) => x.boxNo !== item.boxNo)
              .concat([tagBox])
            setBoxImportItems(newItems)
          }
        }
        break
    }
  }

  // 导入盒子
  const handleBoxImport = async (items: BoxItem[]) => {
    if (onBoxImport) {
      for (const item of items) {
        if (item.comMode === 2 && !item.hardwareId) {
          const tcpBox = await onBoxTcpLoad?.(item.natIp || '')
          if (tcpBox) {
            item.alias = tcpBox.boxNo
            item.boxNo = tcpBox.boxNo
            item.hardwareId = tcpBox.hardwareId
            item.password = tcpBox.password
            item.userPassword = tcpBox.userPassword
          }
        }
      }
      const rep = await onBoxImport(items)
      if (rep.ignored && rep.ignored.length > 0) {
        for (const item of rep.ignored) {
          message.error(
            formatMessage({
              id: 'app.box.import.exists',
              parameters: { boxNo: item.boxNo }
            })
          )
        }
      }
      setBoxImportVisible(false)
      setBoxImportItems([])
      // 重新加载盒子列表
      await loadBoxes(0)
    }
  }

  // 删除盒子
  const handleBoxDelete = async (items: BoxItem[]) => {
    if (items.length <= 0) return
    const msg = items.map((x) => `【${x.boxNo}】`).join('、')
    Modal.confirm({
      title: formatMessage({ id: 'app.modal.title' }),
      content: formatMessage({
        id: 'app.box.prompt.delete',
        parameters: { boxNos: msg }
      }),
      okText: formatMessage({ id: 'app.modal.ok' }),
      cancelText: formatMessage({ id: 'app.modal.cancel' }),
      onOk: async () => {
        if (onBoxDelete) {
          try {
            await onBoxDelete(items)
            await loadBoxes(0)
          } catch (error) {
            console.log(items)
          }
        }
      }
    })
  }

  // 清除盒子配置
  const handleBoxClean = async (items: BoxItem[]) => {
    if (items.length <= 0) return
    const msg = items.map((x) => `【${x.boxNo}】`).join('、')
    Modal.confirm({
      title: formatMessage({ id: 'app.modal.title' }),
      content: formatMessage({
        id: 'app.box.prompt.clean',
        parameters: { boxNos: msg }
      }),
      okText: formatMessage({ id: 'app.modal.ok' }),
      cancelText: formatMessage({ id: 'app.modal.cancel' }),
      onOk: async () => {
        try {
          await onBoxClean?.(items)
          await onBoxReboot?.(items)
          showBoxBatchMessage(items, 'success', 'app.box.prompt.cleanSuccess')
        } catch (error) {
          console.log(error)
        }
      }
    })
  }

  // 重启盒子
  const handleBoxReboot = (items: BoxItem[]) => {
    if (onBoxReboot) {
      const boxNos = items.map((x) => `【${x.boxNo}】`).join('、')
      Modal.confirm({
        title: formatMessage({ id: 'app.modal.title' }),
        content: formatMessage({
          id: 'app.box.prompt.reboot',
          parameters: { boxNos: boxNos }
        }),
        onOk: async () => {
          try {
            await onBoxReboot(items)
          } catch (error) {
            console.log(items)
          }
        }
      })
    }
  }

  // 更新固件
  const handleBoxFirmwareUpdate = async (firmware: BoxFirmwareItem) => {
    if (onBoxFirmwareUpdate) {
      try {
        setBoxFirmwareVisible(false)
        showBoxJobModal()
        await onBoxFirmwareUpdate(boxBatchItems, firmware)
      } catch (error) {}
    }
  }

  // 关联模板
  const handleBoxContact = async (
    boxItems: BoxItem[],
    template: TemplateItem,
    modules: string[]
  ) => {
    if (onTemplateApply) {
      try {
        setBoxContactVisible(false)
        await onTemplateApply(template, boxItems, modules)
      } catch (error) {}
    }
  }

  // 编辑盒子信息
  const handleBoxEdit = async (boxItem: BoxItem, item: BoxUpdateItem) => {
    if (onBoxUpdate) {
      try {
        await onBoxUpdate([boxItem], item)
        setBoxEditVisible(false)
        updateBox(Object.assign(boxItem, item))
      } catch (error) {}
    }
  }

  // 收藏盒子
  const handleBoxFavorite = async (item: BoxItem, favorite: boolean) => {
    if (onBoxFavorite) {
      try {
        await onBoxFavorite(item, favorite)
        const i = boxes.findIndex((x) => x.id === item.id)
        if (i >= 0) {
          let newList = [...boxes]
          newList[i].favorite = favorite
          newList.sort(sortBox)
          setBoxes(newList)
        }
      } catch (error) {}
    }
  }

  // 显示盒子批量操作提示信息
  const showBoxBatchMessage = (
    items: BoxItem[],
    type: 'success' | 'error',
    key: string
  ) => {
    for (const box of items) {
      if (type === 'success') {
        message.success(
          formatMessage({
            id: key,
            parameters: { boxNo: box.boxNo }
          })
        )
      }
      if (type === 'error') {
        message.error(
          formatMessage({
            id: key,
            parameters: { boxNo: box.boxNo }
          })
        )
      }
    }
  }

  // 更新多个盒子连接参数
  const handleBoxCheckConnectionUpdate = async (item: BoxConnectionItem) => {
    if (onBoxConnectionUpdate) {
      try {
        await onBoxConnectionUpdate(boxBatchItems, item)
        await onBoxReboot?.(boxBatchItems)
        setBoxConnectionEditVisible(false)
        showBoxBatchMessage(
          boxBatchItems,
          'success',
          'app.box.prompt.connectionSuccess'
        )
      } catch (error) {
        logger.error(error)
      }
    }
  }

  // 更新多个盒子时钟服务器
  const handleBoxCheckTimeUpdate = async (item: BoxTimeItem) => {
    if (onBoxTimeUpdate) {
      try {
        await onBoxTimeUpdate(boxBatchItems, item)
        setBoxTimeEditVisible(false)
        showBoxBatchMessage(
          boxBatchItems,
          'success',
          'app.box.prompt.timeSuccess'
        )
        if (
          boxSelectItem &&
          boxBatchItems.findIndex((x) => x.id === boxSelectItem.id) >= 0
        ) {
          const newBox = { ...boxSelectItem }
          updateBox(newBox)
        }
      } catch (error) {
        logger.error(error)
      }
    }
  }

  // 盒子升级失败
  const handleBoxFailedUpgrade = (item?: BoxItem) => {
    // 关闭升级对话框
    setBoxUpgradeVisible(false)
    // 显示错误消息
    Modal.error({
      title: formatMessage({ id: 'app.box.upgrade.failed.title' }),
      content: '设备升级失败',
      okText: formatMessage({ id: 'app.box.upgrade.failed.retry' }),
      cancelText: formatMessage({ id: 'app.modal.cancel' }),
      okCancel: true,
      onOk: () => {
        // 重试
        if (item) {
          handleBoxOldFirmwareUpdate(item)
        }
      },
      onCancel: () => {
        // 取消
        setBoxHandleItem(undefined)
      }
    })
  }

  // 老版本固件升级
  const handleBoxOldFirmwareUpdate = async (item: BoxItem) => {
    setBoxUpgradeVisible(true)
    try {
      await onBoxOldFirmwareUpdate?.([item])
    } catch (error) {
      handleBoxFailedUpgrade(item)
    }
  }

  // 处理盒子异常
  const handleBoxError = (item: BoxErrorItem) => {
    // 如果当前已经存在待处理的设备，则跳过
    if (boxHandleItem) {
      logger.warn(
        `设备${boxHandleItem.boxNo}已经在处理异常中，跳过: ${item.boxNo} 的异常处理。`
      )
      return
    }
    const boxItem = boxes.find((x) => x.boxNo === item.boxNo)
    if (!boxItem) return
    setBoxHandleItem(boxItem)

    switch (item.code) {
      // 版本号不支持
      case BoxErrorCode.VersionError:
      case BoxErrorCode.FloaderError:
        Modal.confirm({
          title: '系统提示',
          content: `设备【${item.boxNo}】当前固件不支持，是否需要升级？`,
          okText: '升级',
          onOk: () => {
            handleBoxOldFirmwareUpdate(boxItem)
          },
          onCancel: () => {
            setBoxHandleItem(undefined)
          }
        })
        break

      // 模式不支持
      case 9000:
      case 9001:
      case 9002:
      case BoxErrorCode.ModeError:
        Modal.confirm({
          title: '系统提示',
          content:
            '当前设备不支持此工具，是否切换模式？切换后设备将从原服务器离线。',
          onOk: async () => {
            setBoxHandleItem(undefined)
            try {
              // 设置连接模式
              await onBoxConnectionUpdate?.([boxItem], {
                mode: 'mqtt',
                server: '',
                keepAlive: 60, // 心跳     (默认 60s)
                connectTimeout: 10, // 连接超时 (默认 10s)
                cleansession: 1, // 会话保持（默认 不启用）
                mqttVersion: '5.0', // 协议版本 (默认 5.0)
                connectStatus: true
              })
              await onBoxReboot?.([boxItem], { force: true })
            } catch {}
          },
          onCancel: () => {
            setBoxHandleItem(undefined)
          }
        })
        break

      // 连接超时
      case BoxErrorCode.ConnectError:
        if (boxItem.comMode === 2) {
          Modal.confirm({
            title: '系统提示',
            content: `设备【${item.boxNo}】连接超时，你可以尝试移除设备后重新添加，或者执行【重置连接】尝试修复。`,
            okText: '重置连接',
            cancelText: '取消',
            onOk: async () => {
              try {
                await onBoxNatIpUpdate?.(boxItem, true)
              } catch (error) {
                Modal.error({
                  title: '系统提示',
                  content: `盒子【${item.boxNo}】连接重置失败，请移除设备后重新添加`
                })
              } finally {
                setBoxHandleItem(undefined)
              }
            },
            onCancel: () => {
              setBoxHandleItem(undefined)
            }
          })
        } else if (boxItem.comMode === 1) {
          Modal.warn({
            title: '系统提示',
            content: `设备【${item.boxNo}】连接超时，请检查设备USB是否连接正确。`,
            onOk: () => {
              setBoxHandleItem(undefined)
            }
          })
        } else {
          Modal.warn({
            title: '系统提示',
            content: `设备【${item.boxNo}】连接超时，请检查设备网络配置是否正确。`,
            onOk: () => {
              setBoxHandleItem(undefined)
            }
          })
        }
        break
    }
  }

  // 处理盒子升级完成
  const handleBoxUpgrade = () => {
    // 重新加载数据
    updateBoxState({ id: boxHandleItem?.id!, connectionState: 4 })
    setBoxHandleItem(undefined)
    setBoxUpgradeVisible(false)
  }

  // 显示设备导入模态框
  const handleBoxImportModalShow = () => {
    setBoxImportItems([])
    setBoxImportVisible(true)
  }

  const handleBoxSelect = (item?: BoxItem) => {
    setBoxSelectItem(item)
    onBoxSelect?.(item)
  }

  // 盒子状态变更
  useEffect(() => {
    if (boxStateItem) {
      logger.info(`BoxStateItem change: ${boxStateItem?.connectionState}`)
      // 如果设备正在处理中，则忽略状态变化
      if (boxHandleItem && boxHandleItem.id === boxStateItem.id) {
        logger.warn(`${boxHandleItem.boxNo} is handling, skip update state.`)
        return
      }
      updateBoxState(boxStateItem)
    }
  }, [boxStateItem])

  // 任务进度变更
  useEffect(() => {
    if (boxJobProgressItem) {
      // 打开任务列表(在其它组件中激活盒子列表时，可以使用此方法)
      if (boxJobProgressItem.visible === true && boxJobVisible === false) {
        showBoxJobModal()
        return
      }

      if (boxJobProgressItem.code !== 0) {
        loadJobStates(3)
      } else {
        if (boxJobProgressItem.progress < 100) {
          setJobProgressItem(boxJobProgressItem)
        } else {
          loadJobStates(2)
        }
      }
    }
  }, [boxJobProgressItem])

  // 盒子发现
  useEffect(() => {
    if (boxFoundItem) {
      if (boxImportType !== 1) return
      if (boxFoundItem.alias && !boxFoundItem.alias.startsWith('FBox')) return
      const index = boxImportItems.findIndex(
        (x) => x.boxNo === boxFoundItem.boxNo
      )
      // 过滤重复的序列号
      if (index >= 0) return
      setBoxImportItems(boxImportItems.concat(boxFoundItem))
    }
  }, [boxFoundItem])

  // 盒子出错
  useEffect(() => {
    if (boxErrorItem) {
      handleBoxError(boxErrorItem)
    }
  }, [boxErrorItem])

  // 盒子升级进度
  useEffect(() => {
    if (boxUpgradeItem) {
      // 如果升级失败
      if (boxUpgradeItem.code !== undefined && boxUpgradeItem.code !== 0) {
        handleBoxFailedUpgrade(boxHandleItem)
      }
    }
  }, [boxUpgradeItem])

  // 初始化
  useEffect(() => {
    loadBoxes()
  }, [])

  return (
    <div>
      {listType === 'table' && (
        <Fragment>
          <BoxToolbar
            onImport={handleBoxImportModalShow}
            onSearch={handleSearch}
            onMenuItemClick={handleMenuItemClick}
          />
          <BoxTable
            selectable={true}
            data={boxes}
            pagination={boxTablePagination}
            onSelect={setBoxCheckItems}
            onMenuItemClick={handleMenuItemClick}
          />
        </Fragment>
      )}

      {listType === 'list' && (
        <Fragment>
          <BoxList
            data={boxes}
            onImport={handleBoxImportModalShow}
            onMenuItemClick={handleMenuItemClick}
            selectionType='checkbox'
            selectable={selectable}
            checkedItems={boxCheckItems}
            onCheck={setBoxCheckItems}
            checkAll={checkAll}
            onSelect={handleBoxSelect}
            onFavorite={handleBoxFavorite}
          />
          <BoxActionbar
            selectable={selectable}
            onSelect={() => setSelectable(!selectable)}
            onCheckAll={() => setCheckAll(!checkAll)}
            onMenuItemClick={handleMenuItemClick}
          />
        </Fragment>
      )}
      {/** 导入盒子模态框 */}
      <BoxImportModal
        visible={boxImportVisible}
        boxItems={boxImportItems}
        importTypes={boxImportTypeItems}
        onVisibleChange={setBoxImportVisible}
        onFileSelect={handleFileSelect}
        onTypeChange={() => setBoxImportItems([])}
        onImport={handleBoxImport}
        onSearch={handleImportSearch}
      />
      {/** 固件升级模态框 */}
      <BoxFirmwareModal
        boxItems={boxBatchItems}
        visible={boxFirmwareVisible}
        onVisibleChange={setBoxFirmwareVisible}
        onFirmwareUpdate={handleBoxFirmwareUpdate}
      />
      {/** 关联模板模态框 */}
      <BoxContactModal
        boxItems={boxBatchItems}
        templateItems={templates}
        templateTotal={templateTotal}
        visible={boxContactVisible}
        onVisibleChange={setBoxContactVisible}
        onContact={handleBoxContact}
        onChange={loadTemplates}
      />
      {/** 修改连接模态框 */}
      <BoxDetailConnectionModal
        editItem={boxConnectionEditItem}
        visible={boxConnectionEditVisible}
        onVisibleChange={setBoxConnectionEditVisible}
        onSave={handleBoxCheckConnectionUpdate}
      />
      {/** 修改始终模态框 */}
      <BoxDetailTimeModal
        editItem={boxTimeEditItem}
        visible={boxTimeEditVisible}
        onVisibleChange={setBoxTimeEditVisible}
        onSave={handleBoxCheckTimeUpdate}
      />
      {/** 编辑盒子模态框 */}
      <BoxEditModal
        editItem={boxEditItem}
        visible={boxEditVisible}
        onVisibleChange={setBoxEditVisible}
        onFinish={handleBoxEdit}
      />
      {/** 盒子任务模态框 */}
      <BoxJobListModal
        visible={boxJobVisible}
        onVisibleChange={setBoxJobVisible}
        size='small'
        states={boxJobStates}
        progressItem={jobProgressItem}
        onItemLoad={onJobListLoad}
      />
      {/** 盒子详情模态框 */}
      <BoxDetailDrawer
        visible={boxDetailVisible}
        box={boxSelectItem}
        values={boxValueItems}
        onVisibleChange={setBoxDetailVisible}
        // 以下事件需要传递到最顶层
        onBoxDetailLoad={onBoxDetailLoad}
        onBoxTemplateLoad={onBoxTemplateLoad}
        onBoxAuditListLoad={onBoxAuditListLoad}
        onBoxLogListLoad={onBoxLogListLoad}
        onBoxValueWrite={onBoxValueWrite}
        onBoxValueRead={onBoxValueRead}
        onBoxValueSubscribe={onBoxValueSubscribe}
        onBoxNetworkModeUpdate={onBoxNetworkModeUpdate}
        onBoxNetworkUpdate={onBoxNetworkUpdate}
        onBoxApnUpdate={onBoxApnUpdate}
        onBoxConnectionUpdate={onBoxConnectionUpdate}
        onBoxTimeUpdate={onBoxTimeUpdate}
        onBoxVariablePushChange={onBoxVariablePushChange}
        onBoxAlarmPushChange={onBoxAlarmPushChange}
        onBoxWifiLoad={onBoxWifiLoad}
      />
      {/** 盒子升级模态框 */}
      <BoxUpgradeModal
        visible={boxUpgradeVisible}
        item={boxUpgradeItem}
        onOk={handleBoxUpgrade}
      />
    </div>
  )
}
